import Vue from 'vue'
import App from './App.vue'
import bus from 'vue-bus'
import Config from './config'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'amfe-flexible/index.js'
import { Dialog } from 'vant'
import './utils/getGeolocation.js'
import '@/style/index.less'
// import wx from 'weixin-js-sdk'
// console.log(wx);

// import VConsole from 'vconsole'
// 使用vconsole调试
// Vue.prototype.$vconsole = VConsole;

// import request from '@/utils/request.js'
// console.log(request);

// 禁止选择网页中的文字
document.onselectstart = function() { return false }
/* 引入资源请求插件*/
import VueResource from 'vue-resource'
// 引入cookies
import VueCookie from 'vue-cookies'
/* 使用VueResource插件*/
Vue.use(VueResource)
// 使用VueCookies
Vue.use(VueCookie)
Vue.prototype.$cookie = VueCookie
Vue.use(bus)
// Vant 使用
Vue.use(Vant)
Vue.prototype.Config = Config
Vue.http.options.root = Config.baseURL
Vue.http.interceptors.push((request, next) => {
  console.log('request1111111111111111111', request)
  // const tokenn=window.sessionStorage.getItem("token")
  const userinfo = window.sessionStorage.getItem('token')
  const commercialId = window.sessionStorage.getItem('commercialId')
  const uu = commercialId != 'undefined' ? commercialId : ''
  const storeUserinfo = window.sessionStorage.getItem('tokens')
  const salesman_token = window.localStorage.getItem('salesman_token')
  const salesman_id = window.localStorage.getItem('salesman_id')
  const storeUu = window.sessionStorage.getItem('store_id')
  const identifier = window.sessionStorage.getItem('tag')
  // request.headers.set("token",tokenn)
  console.log('tag', identifier)
  if (identifier === '222') {
    console.log(2222)
    request.headers.set('token', userinfo)
    request.headers.set('merchantid', uu)
  } else if (identifier == '111') {
    request.headers.set('token', storeUserinfo)
    request.headers.set('storeid', storeUu)
  } else if (identifier == 'salesman_log') {
    console.log('=========================================')
    request.headers.set('salesmanid', salesman_id)
    request.headers.set('token', salesman_token)
  }
  console.log(request.headers)
  next((response) => { // 在响应之后传给then之前对response进行修改和逻辑判断。对于token时候已过期的判断，就添加在此处，页面中任何一次http请求都会先调用此处方法
    if (response.data.code == 401 || response.data.code == 403) {
      Dialog.alert({
        message: response.data.msg
      }).then(() => {
        switch (response.data.type) {
          case 'salesman':
            router.push('/SalesmanLogin')
            break
          case 'merchant':
            router.push('/MerchantImpower')
            break
          case 'store':
            router.push('/StoreImpower')
            break
          case 'agent':
            router.push('/AgentImpower')
            break
        }
      })
    } else {
      return response
    }
  })
  // const token_path=["/wechat/user/store_login","/wechat/user/homepage","/wechat/api.merchant_info/get_store_info","/wechat/api.order/get_order"];
  // const isAuth=token_path.includes(request.url);
  // if (!isAuth) {
  //     console.log("商户登录");
  //     request.headers.set("token",userinfo)
  //     request.headers.set("merchantid",uu)

  // }else {
  //     console.log("门店登录");
  //     request.headers.set("token",storeUserinfo)
  //     request.headers.set("storeid",storeUu)
  // }
})

// Vue.http.interceptors.response.push(res => {
//         console.log('response->res:', res)
//         //根据后台返回的状态码而定
//         return res
//     },
//     error => {
//         return Promise.reject(error);
//     }
// );

Vue.config.productionTip = false

const FastClick = require('fastclick')

document.addEventListener('DOMContentLoaded', function() {
  FastClick.attach(document.body)
}, false)
var a = []
router.beforeEach((route, redirect, next) => {
  console.log('to:', route)
  console.log('from:', redirect)
  a.push(route.path)
  console.log('----------------------------------------------------------------------------', a)
  console.log('当前地址', window.location.href)
  console.log('当前location地址', window.location)
  const wechatAuthName = ['Gangway', 'SalesmanSetting']
  // console.log('redirect', redirect);
  console.log('route', route)
  const isAuth = wechatAuthName.indexOf(route.name)
  console.log('isAuth', isAuth)
  // console.log("当前用户的cookie", VueCookie.get('openid'));
  // console.log("获取到的openid", route.query.openid);
  var u = navigator.userAgent
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  if (isiOS && route.path !== location.pathname) {
    // 此处不可使用location.replace
    location.assign(route.fullPath)
  }

  if (isAuth >= 0) {
    var openid = route.query.openid
    var cookie_openid = VueCookie.get('openid')
    // 检验用户信息和openid都没有
    if (!cookie_openid && !openid) {
      // console.log(window.location.href);
      var is_url = route.query.is_url
      // console.log("is_url=",is_url);
      var url = window.location.href
      if (is_url) {
        // console.log("window.location.host=",url.substring(0,url.length-9))
        url = url.substring(0, url.length - 9)
        window.location.href = Config.baseURL + 'wechat/index/authLogin?redirect=' + url + '?is_url=' + is_url
      } else {
        window.location.href = Config.baseURL + 'wechat/index/authLogin?redirect=' + url
      }
    } else {
      if (openid) {
        VueCookie.set('openid', openid)
        Config.openid = openid
      }
    }
  }
  /* 显示加载中动画 */
  store.commit('updateLoadingStatus', true)
  if (route.meta.title) {
    window.document.title = route.meta.title
  }
  next()
})

router.afterEach(function() {
  /* 隐藏加载中动画 */
  store.commit('updateLoadingStatus', false)
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
